module.exports = __webpack_public_path__ + "static/media/plakat-sk.54f7500b.svg";